import { NgModule } from '@angular/core';
import { OrgPickerComponent } from '@go-modules/components/org-picker/org-picker.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
	imports: [
		GoMaterialModule,
		CommonModule,
		NgSelectModule,
		FormsModule,
		ReactiveFormsModule
	],
	declarations: [
		OrgPickerComponent
	],
	exports: [
		OrgPickerComponent
	]
})
export class OrgPickerModule {}
